/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import HeaderComponent from "../../Pages/Header/Header";
import contact_img from "../../images/contact-us-img.png";
import "./contact.css";
import FooterComponent from "../../Pages/Footer/Footer";
import { useDispatch } from "react-redux";
import { contactUs } from "../../Services/Community/CommunityAPI/communityApi";
import { toast } from "react-toastify";

function ContactPageComponent() {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    telephone: "",
    subject: "",
    message: ""
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [sent, setSent] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "telephone") {
      // Auto-format phone number to (XXX) XXX-XXXX format
      let formattedValue = value.replace(/[^\d]/g, "");
      if (formattedValue.length <= 3) {
        formattedValue = `(${formattedValue}`;
      } else if (formattedValue.length <= 6) {
        formattedValue = `(${formattedValue.slice(0, 3)}) ${formattedValue.slice(3)}`;
      } else {
        formattedValue = `(${formattedValue.slice(0, 3)}) ${formattedValue.slice(3, 6)}-${formattedValue.slice(6, 10)}`;
      }
      setFormData({ ...formData, [name]: formattedValue });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;

    if (!formData.name) newErrors.name = "Name is required.";
    if (!formData.email || !emailRegex.test(formData.email)) newErrors.email = "Please enter a valid email.";
    if (!formData.subject) newErrors.subject = "Subject is required.";
    if (!formData.message) newErrors.message = "Message is required.";
    if (formData.telephone && !phoneRegex.test(formData.telephone)) newErrors.telephone = "Please enter a valid phone number.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return; // Prevent submission if validation fails

    setLoading(true);

    try {
      const res = await dispatch(contactUs(formData)); // Dispatch the action with form data
      if (res?.payload?.status === 201) {
        setSent("send")
        toast.success(res?.payload?.message)
      }
    } catch (err) {
      console.error("Error in contact submission:", err);
      setSent("failed")
    } finally {
      setLoading(false);
      setFormData({
        name: "",
        email: "",
        telephone: "",
        subject: "",
        message: ""
      })
    }
  };

  return (
    <>
      <HeaderComponent />
      <div className="contact-us-page-section text-center container">
        <h1 className="mt-4 mb-4">We're Here To Help!</h1>
        <div className="contact-content">
          <div className="contact-image">
            <img src={contact_img} alt="contact-image"></img>
          </div>
          <div className="contact-info-para mt-4 mb-5">
            <p className="m-0 mb-5">
              At HOA Verified, we are here to assist you with all your
              Homeowners' Association needs. Whether you have questions about
              compliance, need help navigating our platform, or require support
              with any other aspect of our services, our dedicated team is ready
              to help. Please don't hesitate to reach out to us via phone,
              email, or the contact form below. Your satisfaction is our top
              priority, and we look forward to serving you
            </p>
            <p>
              <span>Need help getting started?</span> Our User Guide will walk
              you through setting up your account.{" "}
              <a href="#">
                Access it here{" "}
                <i className="fa fa-angle-right" aria-hidden="true"></i>
                <i className="fa fa-angle-right" aria-hidden="true"></i>
              </a>
            </p>
          </div>
          <div className="contact-us-block-form text-start">
            <h1 className="mb-5 text-center">Contact Us</h1>
            <div className="form-block">
              <form onSubmit={handleSubmit}>
                <div className="form-group mb-3">
                  <label htmlFor="name" className="mb-1">
                    Name*
                  </label>
                  <br></br>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                  {errors.name && <span className="error-text">{errors.name}</span>}
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="community" className="mb-1">
                    Email*
                  </label>
                  <br></br>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                  {errors.email && <span className="error-text">{errors.email}</span>}
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="telephone" className="mb-1">
                    Telephone
                  </label>
                  <br></br>
                  <input
                    type="telephone"
                    id="telephone"
                    name="telephone"
                    value={formData.telephone}
                    onChange={handleChange}
                  />
                  {errors.email && <span className="error-text">{errors.telephone}</span>}
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="subject" className="mb-1">
                    Subject*
                  </label>
                  <br></br>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  />
                  {errors.email && <span className="error-text">{errors.subject}</span>}
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="message" className="mb-1">
                    Message*
                  </label>
                  <br></br>
                  <textarea
                    className="w-100"
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                  {errors.email && <span className="error-text">{errors.message}</span>}
                </div>
                <div className="text-center">
                  <button type="submit" className="btn-orange" disabled={loading}>
                    {loading ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </form>
              {sent === "sent" && <p>Message sent successfully</p>}
              {sent === "failed" && <p>Failed to send message</p>}
            </div>
          </div>
        </div>
      </div>
      <FooterComponent />
    </>
  );
}

export default ContactPageComponent;
